<template>
  <div class="mb-2">
    <b-card no-body>
      <b-list-group flush>
        <b-list-group-item>
          <b-row class="justify-content-between align-items-center">
            <b-col>Halo Bubbles Filters</b-col>
            <b-col cols="5">
              <b-button
                variant="outline-primary"
                block
                @click="addCustomBubblesGroup"
              >
                <font-awesome-icon icon="plus" />
              </b-button>
            </b-col>
          </b-row>
        </b-list-group-item>
        <b-list-group-item
          v-for="key in customBubblesGroupsKeys"
          :key="`${key}`"
        >
          <b-row class="justify-content-between align-items-center">
            <b-col>{{ customBubblesGroups[key].name }}</b-col>
            <b-col cols="5">
              <b-button-group class="w-100">
                <b-button
                  variant="outline-info"
                  @click="$bvModal.show(`${key}-modal-id`)"
                >
                  <font-awesome-icon icon="edit" />
                </b-button>
                <b-button
                  variant="outline-danger"
                  @click="removeCustomBubblesGroup(key)"
                >
                  <font-awesome-icon icon="minus" />
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <CustomBubblesGroupFilters
      v-for="key in customBubblesGroupsKeys"
      :key="`${key}-modal-key`"
      :custom-bubbles-group-id="key"
      :custom-bubbles-group="customBubblesGroups[key]"
      @update:custom-bubbles-group="setCustomBubblesGroupFilters(key, $event)"
    />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import CustomBubblesGroupFilters from '@/components/builder/CustomBubblesGroup/CustomBubblesGroupFilters.vue'

import { CUSTOM_BUBBLES_GROUPS_CONFIG_KEY } from '@/constants'

import { CustomBubblesGroups, CustomBubblesFilters } from '@/types'

// @ts-ignore uuid not having types
import { v4 as uuidv4 } from 'uuid'

const components = {
  LabelledInput,
  CustomBubblesGroupFilters,
}

@Component({ components })
export default class CustomBubblesGroupSettings extends Vue {
  get customBubblesGroupsKeys () {
    return Object.keys(this.customBubblesGroups)
  }

  get customBubblesGroups () {
    return this.$typedStore.primary.app.config[CUSTOM_BUBBLES_GROUPS_CONFIG_KEY]
  }

  set customBubblesGroups (value: CustomBubblesGroups) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [CUSTOM_BUBBLES_GROUPS_CONFIG_KEY],
      value,
    })
  }

  setCustomBubblesGroupFilters (key: string, value: CustomBubblesFilters) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [CUSTOM_BUBBLES_GROUPS_CONFIG_KEY, key],
      value,
    })
  }

  addCustomBubblesGroup () {
    this.setCustomBubblesGroupFilters(`custom-bubbles-group-id-${uuidv4()}`, {
      name: `Custom Bubbles Filter ${this.customBubblesGroupsKeys.length + 1}`,
      filters: [],
    })
  }

  removeCustomBubblesGroup (removeKey: string) {
    this.customBubblesGroups = this.customBubblesGroupsKeys
      .filter(key => key !== removeKey)
      .reduce((groups: CustomBubblesGroups, key: string) => {
        groups[key] = this.customBubblesGroups[key]
        return groups
      }, {})
  }
}

</script>
